import { fetchRequestWithTypes } from './index.js';

export const GET_PX_QUESTIONS_REQUEST = 'GET_PX_QUESTIONS_REQUEST';
export const GET_PX_QUESTIONS_SUCCESS = 'GET_PX_QUESTIONS_SUCCESS';
export const GET_PX_QUESTIONS_ERRORED = 'GET_PX_QUESTIONS_ERRORED';

export const getQuestions = (oId) => {
	return fetchRequestWithTypes({
		types: [GET_PX_QUESTIONS_REQUEST, GET_PX_QUESTIONS_SUCCESS, GET_PX_QUESTIONS_ERRORED],
		pxQuestionType: oId,
		request: {
			method: 'GET',
			path: `/apis/customers/v1/questions/${oId}`,
		},
	});
};

export const PUT_PX_QUESTIONS_REQUEST = 'PUT_PX_QUESTIONS_REQUEST';
export const PUT_PX_QUESTIONS_SUCCESS = 'PUT_PX_QUESTIONS_SUCCESS';
export const PUT_PX_QUESTIONS_ERRORED = 'PUT_PX_QUESTIONS_ERRORED';

export const putQuestions = (oId, answer) => {
	return fetchRequestWithTypes({
		types: [PUT_PX_QUESTIONS_REQUEST, PUT_PX_QUESTIONS_SUCCESS, PUT_PX_QUESTIONS_ERRORED],
		pxQuestionType: oId,
		request: {
			method: 'PUT',
			path: `/apis/customers/v1/questions/${oId}`,
			body: {
				answer: {
					value: answer,
				},
			},
		},
	});
};

// Local-only action: clears a previously-cached PX question entry from Redux
// state so any predicate that gates on `answer.value` flips back to false.
// Used when the user intentionally backs out of a screen whose answer should
// be re-collected (e.g. C&R multi-goal users returning to the narrowing UI).
export const CLEAR_PX_QUESTION = 'CLEAR_PX_QUESTION';

export const clearPxQuestion = (pxQuestionType) => ({
	type: CLEAR_PX_QUESTION,
	pxQuestionType,
});
